<template>
<div>
  <v-container fluid justify-center>
    <v-layout justify-center align-center>
      <v-flex xs10 class="mt-4 has-text-centered">
        <img src="/static/img/alumisel-120x32.png" />
      </v-flex>
    </v-layout>
  </v-container>

  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg4 sm6 xs12 v-for="item in navigation" :key="item.title">
        <router-link :to="{name: item.route}" tag="div" class="pointer">
          <v-card elevation="0">
            <v-card-title>
              <v-avatar>
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
              </v-avatar>
              <div class="ml-3">
                <span class="headline">{{ item.title }}</span>
                <P>{{ item.subtitle }}</p>
              </div>
            </v-card-title>
          </v-card>
        </router-link>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import mutationsMixin from '@/mixins/mutationsMixin'

  export default {
    computed: {
      ...mapGetters(['navigation'])
    },
    mixins: [mutationsMixin]
  }
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue